type CallBack = () => Promise<unknown>;

export class ThrottledPromises {
    private executing: CallBack | undefined;
    private pending: CallBack[] = [];

    public queue(cb: CallBack) {
        if (this.executing) {
            this.pending.push(cb);
        } else {
            this.execute(cb);
        }
    }

    private execute(cb: CallBack) {
        this.executing = cb;
        const promise = cb();
        if (promise?.finally) {
            promise.finally(this.onHandleResult.bind(this));
        } else {
            this.onHandleResult();
        }
    }

    private onHandleResult() {
        this.executing = undefined;

        if (this.pending.length > 0) {
            const next = this.pending.splice(0, 1)[0];
            this.execute(next);
        }
    }
}
